// extracted by mini-css-extract-plugin
export default {"statsSection":"Stats_statsSection__QRUYv","container":"Stats_container__Wuk1T","grid":"Stats_grid__yLRxR","statValue":"Stats_statValue__hS71t","statLabel":"Stats_statLabel__hfRL+"};